/*
 * Copyright (c) 2025. Sergey S. Chernov - All Rights Reserved
 *
 *  You may use, distribute and modify this code under the
 * terms of the private license, which you must obtain from the author
 *
 * To obtain the license, contact the author: https://t.me/real_sergeych or email to
 * real dot sergeych at gmail.
 */

package net.sergeych.crypto2

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable
import kotlinx.serialization.Transient

/**
 * Combination of public keys suitable for both encryption and verification. A counterpart
 * of the [UniversalPrivateKey], available also as [UniversalPrivateKey.publicKey].
 *
 * When using [UniversalRing] and [Container], data encrypted with instances og this class
 * can be decrypted with rings containing the corresponding [UniversalPrivateKey].
 */
@Serializable
@SerialName("upub")
class UniversalPublicKey(
    val verifyingKey: VerifyingPublicKey,
    val encryptingKey: EncryptingPublicKey
): UniversalKey(), VerifyingKey by verifyingKey, EncryptingKey by encryptingKey{

    override val keyBytes by lazy { verifyingKey.keyBytes + encryptingKey.keyBytes }

    @Transient
    override val magic = KeysmagicNumber.defaultUniversalPublic

    /**
     * Important! Private key combines signing and decrypting keys, but uses
     * it of the decrypting one to be used in keyring.
     */
    @Transient
    override val id: KeyId = encryptingKey.id


}